import Vue from 'vue'
import Vuex from 'vuex'
import {ObjectsWithId, Lead, Payout} from 'src/classes/datamodel.js'
import api from './apiServices.js'
import router from '../router/router.js'
import NProgress from 'nprogress'
import apiServices from './apiServices.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      userSession: '',
      periodSelected: {}, // {value: 'this month', label: 'This Month' previous: 'Last Month', evo: 'Last 12 Months'}
      companySelected: 0,
      modal: { mode: '', current: '', object: {} },
      selectedObjects: { objectsJson: null, filter: null }, // Select mode is initiated in tables when objectsJson != null
      classes: {
        Payout: {
          _status: Payout._status,
          _type: Payout._type
        },
        Lead: {
          _status: Lead._status
        }
      },
      data: {
        leadsJson:       new ObjectsWithId(),
        payoutsJson:     new ObjectsWithId(),
        paymentCardLogs: []
      },
      dataPrevious: {
        leadsJson:       new ObjectsWithId(),
        payoutsJson:     new ObjectsWithId(),
        paymentCardLogs: []
      },
      dataEvolution: { // for the graphs displaying evolution over the year
        affiliates: { lineChart: {}, pieChart: {}, barChart: {} },
        leads:      { lineChart: {}, pieChart: {}, barChart: {} },
        payouts:    { lineChart: {}, pieChart: {}, barChart: {} }
      },
      baseData: {
        incentifyerAccountsJson: {},
        periods: [],
        affiliateCompany: {},
        affiliateUser: {
          firstName: '',
          lastName: '',
          email: '',
          email2: '',
          address: {
            addressLine1: '',
            addressLine2: '',
            country: '',
            city: '',
            state: '',
            postalCode: ''
          },
          timezoneOffset: undefined,
        },
        paymentCards: [{
          paymentCardProviderId: 0,
          id: 0,
          dateActivation: '',
          dateExpiration: '',
          status: '',
          balance: 0
        }],
        paymentCardBalances: [-1],
        accountSetup: {}

      }
    },





    /////////////////////////////////////////////////////
    ///////////////////// GETTERS ///////////////////////
    /////////////////////////////////////////////////////
    getters: {
      currency                () { return '$' }, 
      periodSelected     (state) { return state.periodSelected },
      companySelected    (state) { return state.companySelected },
      accountSetup       (state) { return state.baseData.accountSetup },
      affiliateCompany   (state) { return state.baseData.affiliateCompany || {} },
      affiliateUser      (state, getters) { return state.baseData.affiliateUser },
      paymentCard        (state, getters) { return state.baseData.paymentCards ? state.baseData.paymentCards[0] || {} : {}},
      periods            (state) { return state.baseData.periods },
      modal              (state) { return state.modal },

      Payout             (state) { return state.classes.Payout },
      Lead               (state) { return state.classes.Lead },

      session            (state) { return state.userSession || JSON.parse(localStorage.getItem('userSession')) },
      user               (state, getters) { return getters.session.user },
      userStatus         (state, getters) { return getters.affiliateUser ? getters.affiliateUser.status || '' : '' },

      leadsJson (state, getters) { return state.data.leadsJson.forCompanyId(getters.companySelected) },
      leads (state, getters) { return getters.leadsJson.values },
      leadsPreviousJson (state, getters) { return state.dataPrevious.leadsJson.forCompanyId(getters.companySelected,
                                                                                           {affiliates: getters.affiliatesJson}) },
      leadsPrevious (state, getters) { return getters.leadsPreviousJson.values },
      /* leadsEvolutionJson (state, getters) { return state.dataEvolution.leadsJson.forCompanyId(getters.companySelected) }, */
      leadsEvolution (state, getters) { return state.dataEvolution.leads[getters.companySelected] },

      incentifyersJson (state) { return state.baseData.incentifyerAccountsJson || new ObjectsWithId() },
      incentifyers (state, getters) { return getters.incentifyersJson.values },

      payoutsJson (state, getters) { return state.data.payoutsJson.forCompanyId(getters.companySelected,
                                                                  {affiliates: getters.affiliatesJson})},
      payouts (state, getters) { return getters.payoutsJson.values },
      payoutsPreviousJson (state, getters) {
        return state.dataPrevious.payoutsJson.forCompanyId(getters.companySelected,
                                                          {affiliates: getters.affiliatesJson})},
      payoutsPrevious (state, getters) { return getters.payoutsPreviousJson.values },
      /* payoutsEvoluionJson (state, getters) {
        return state.dataEvolution.payoutsJson.forCompanyId(getters.companySelected,
                                                            {affiliates: getters.affiliatesJson})}, */
      payoutsEvolution (state, getters) { return state.dataEvolution.payouts[getters.companySelected] },
      
      selectedObjectsJson (state) {
        return state.selectedObjects.objectsJson
      },

      selectedObjects (state, getters) {
        return getters.selectedObjectsJson ? getters.selectedObjectsJson.values : null
      },
      
      selectedObjectsFilter (state) {
        return state.selectedObjects.filter
      },
      paymentCardLogs (state) { return state.data.paymentCardLogs },
      isXtmActive (state, getters) {
        // console.log('process.env = ', process.env)
        return JSON.parse(process.env.VUE_APP_XTM_INTEGRATION_ACTIVE) == true
      },
      




      





    /////////////////////////////////////////////////////
    //////////////////// FUNCTIONS //////////////////////
    /////////////////////////////////////////////////////
      affiliatesLeads (state, getters) { // returns all affiliates with their leads leads and totals
        var res = {}
        getters.affiliates.forEach(aff => {
          console.log('1: aff.id = ', aff.id)
          var leads = { total: 0, closed: 0, lost: 0, closeRate: 0, leads: [] }
          getters.leads.forEach(lead => {
            console.log('2: lead.affiliateId = ', lead.affiliateId)
            if (lead.affiliateId == aff.id) {
              leads.total += 1
              switch (lead.status) {
                case Lead._status.CLOSED.value:
                  leads.closed += 1
                  break
                case Lead._status.LOST.value:
                  leads.lost += 1
                  break
                default:
                  break
              }
            }
            console.log('3: leads = ', leads)
          })
          leads.closeRate = leads.closed ? Math.round(100 * leads.closed / leads.total) : 0
          res[aff.id] = leads
        })
        return res
      },
      totalLeads (state, getters) {
        //console.log('totalLeads: ', getters.leads.length)
        return getters.leads.length || 0
      },
      totalLeadsPrevious (state, getters) {
        return getters.leadsPrevious.filter(l => l.archived != true).length || 0
      },
      totalLeadsClosed (state, getters) {
        var total = 0
        getters.leads.forEach(elem => {
          if (elem.archived != true) {
            total += elem.status == Lead._status.CLOSED.value ? 1 : 0
          }
        })
        return total
      },
      totalLeadsClosedPrevious (state, getters) {
        var total = 0
        getters.leadsPrevious.forEach(elem => {
          if (elem.archived != true) {
            total += elem.status == Lead._status.CLOSED.value ? 1 : 0
          }
        })
        return total
      },
      // Returns true is minimum necessary setup data is present
      // isSetupComplete (state, getters) {
      //   var bd = state.baseData
      //   let ap = bd.affiliateProfile
      //   var res = ap.firstName && ap.lastName && ap.password && ap.email && ap.affiliateCompany && ap.workEmail && ap.position
      //             && ap.address && ap.address.addressLine1 && ap.address.city && ap.address.country && ap.address.state && ap.address.postalCode
      //             && ap.timezoneOffset
      //   return res
      // },
      // Return the evolution period corresponding to the currentyl selected period
      periodEvolution (state, getters) {
        let period = getters.periods.find(p => p.value == getters.periodSelected.evolution)
        if (period) {
          return period
        }
        else {
          return {}
        }
      },


      




    /////////////////////////////////////////////////////
    ////////////// FUNCTIONS WITH ARGUMENTS /////////////
    /////////////////////////////////////////////////////
      // Functions with arguments:
      totalPayouts: (state, getters) => obj => {
        let total = 0
        let payouts = getters.payouts.filter(p =>  !p.archived)
        if (obj && obj.status) {
          payouts = payouts.filter(p => p.status == obj.status.value)
        }
        payouts.forEach(elem => {
          total += elem.amount || 0
        })
        return total
      },
      totalPayoutsPrevious: (state, getters) => obj => {
        let total = 0
        let payouts = getters.payoutsPrevious
        if (obj && obj.status) {
          payouts = payouts.filter(p => p.status == obj.status.value)
        }
        payouts = payouts.filter(p => p.archived != true)
        payouts.forEach(elem => {
          total += elem.amount || 0
        })
        return total
      },
      getIncentifyerName: (state, getters) => incentifyerAccountId => {
        var res = getters.incentifyers.find(elem => elem.id == incentifyerAccountId)
        return res ? res.profile.companyName : '-'
      },
      // getAffiliateName: (state, getters) => affiliateId => {
      //   var res = getters.affiliates.find(elem => elem.id == affiliateId)
      //   return res ? res.firstName + ' ' + res.lastName : '-'
      // },
      getPayoutsForAffiliate: (state, getters) => arg => {
        var affiliateId = null
        if (typeof arg == 'object') {
          affiliateId = arg.id
        } else {
          affiliateId = Number(arg)
        }
        if (affiliateId == null || affiliateId == 0) {
          // TODO: we'll return payouts for all affiliates
        }

        var payouts = {
          total: 0,
          pending: 0,
          paid: 0,
          payouts: []
        }
        getters.payouts.filter(p => !p.archived).forEach(elem => {
          //console.log('getPayoutsForAffiliate:', elem.amount)
          if (!affiliateId || elem.affiliateId == affiliateId) {
            if (Number(elem.amount) && elem.amount > 0) {
              payouts.total += elem.amount
              payouts.payouts.push(elem)
              switch (elem.status) {
                case Payout._status.PAID.value:
                  payouts.paid += elem.amount
                  break
                default:
                  payouts.pending += elem.amount
                  break
              }
            }
          }
        })
        return payouts
      },
      /** This function is needed because if only the total property is used for the result of getPayoutsForAffiliate(), the reactivity doesn't work */
      // getPayoutsTotalForAffiliate: (state, getters) => arg => {
      //   return getters.getPayoutsForAffiliate(arg).total

      // },
      getPayoutsForCompany: (state, getters) => arg => {
        var companyId = null
        if (typeof arg == 'object') {
          companyId = arg.id
        } else {
          companyId = Number(arg)
        }
        if (companyId == null || companyId == 0) {
          // we'll return payouts for all companies
        }

        var payouts = {
          total: 0,
          pending: 0,
          paid: 0,
          payouts: []
        }
        getters.payoutsJson.forCompanyId(companyId).values.forEach(elem => {
          //console.log('getPayoutsForAffiliate:', elem.amount)
          if (!companyId || elem.affiliateId == affiliateId) {
            if (Number(elem.amount) && elem.amount > 0) {
              payouts.total += elem.amount
              payouts.payouts.push(elem)
              switch (elem.status) {
                case Payout._status.PAID.value:
                  payouts.paid += elem.amount
                  break
                default:
                  payouts.pending += elem.amount
                  break
              }
            }
          }
        })
        return payouts
      },

      //////////////////// User Permissions: ///////////////////
      // returns trus is user has this permission
      isPermitted: (state, getters) => permission => {
        let permissions = getters.affiliateUser.permissions
        //TODO
        return true
      }
    },
    






    /////////////////////////////////////////////////////
    ///////////////////// MUTATIONS /////////////////////
    /////////////////////////////////////////////////////
    mutations: {
      // UPDATE_DATA (state, payload) {
      //   //console.log('payload: ', payload)
      //   state.data = payload
      // },
      // UPDATE_DATA_PREVIOUS (state, payload) {
      //   state.dataPrevious = payload
      // },
      // UPDATE_DATA_EVOLUTION (state, payload) {
      //   state.dataEvolution = payload
      // },


      UPDATE_LEADS (state, leads) {
        state.data.leadsJson = leads
      },
      UPDATE_LEADS_PREVIOUS (state, leads) {
        state.dataPrevious.leadsJson = leads
      },
      UPDATE_LEADS_EVOLUTION (state, leads) {
        state.dataEvolution.leads = leads
      },
      UPDATE_PAYOUTS (state, payouts) {
        state.data.payoutsJson = payouts
      },
      // UPDATE_PAYOUT (state, payout) {
      //   state.data.payoutsJson[payout.id] = payout
      // },
      UPDATE_PAYOUTS_PREVIOUS (state, payouts) {
        state.dataPrevious.payoutsJson = payouts
      },
      UPDATE_PAYOUTS_EVOLUTION (state, payouts) {
        state.dataEvolution.payouts = payouts
      },
      UPDATE_PAYMENT_CARD_LOGS (state, paymentCardLogs) {
        state.data.paymentCardLogs = paymentCardLogs
      },
      UPDATE_PAYMENT_CARD_LOGS_PREVIOUS (state, paymentCardLogs) {
        state.dataPrevious.paymentCardLogs = paymentCardLogs
      },


      UPDATE_BASE_DATA (state, payload) {
        console.log('UPDATE_BASE_DATA, payload = ', payload)
        state.baseData = payload
      },
      STORE_SESSION (state, userSession) {
        localStorage.setItem('userSession', JSON.stringify(userSession))
        state.userSession = userSession
      },
      /** This methods removes the token and user from local storage and removes the session in the state */
      CLEAR_SESSION (state) {
        let userSession = state.userSession
        console.log('CLEAR_SESSION, userSession = ', userSession)
        if (userSession && userSession.token) {
          userSession.token = ''
          userSession.user = ''
          localStorage.setItem('userSession', JSON.stringify(userSession))
          state.userSession = ''
        }
      },



      //////////////////////////// Other: ////////////////////////////
      SET_PERIOD_SELECTED (state, period) {
        if (typeof period == 'string') {
          state.periodSelected = state.baseData.periods.find(p => p.value == period)
        }
        else {
          state.periodSelected = period
        }
      },
      SET_COMPANY_SELECTED (state, company) { // can take either AffiliateCompany or companyId as parameter
        state.companySelected = company.id || company
      },
      OPEN_MODAL (state, arg) {
        console.log('OPEN_MODAL: ', arg)
        // Lead modal:
        if (arg.name == 'Lead') {
          switch (arg.mode) {
            case 'Create':
              state.modal.object = arg.object || new Lead({status: Lead._status.RECEIVED.value})
              break;
            case 'Close':
              state.modal.object = arg.object || new Lead({status: Lead._status.CLOSED.value})
              console.log('close')
              break;
            case 'Lost':
              console.log('lost')
              state.modal.object = arg.object || new Lead({status: Lead._status.LOST.value})
              break;  
            case 'Edit':
              console.log('Edit')
            default:
              state.modal.object = arg.object || new Lead()
              break;
          }
          if (arg.mode == 'Close' || arg.mode == 'Lost') {
            // we activate the table row select mode (checkboxes)
            state.selectedObjects.objectsJson = new ObjectsWithId()
          }
        } else {
          // Other modals
          state.modal.object = arg.object
        }
        
        state.modal.mode = arg.mode || ''
        state.modal.current = arg.name
      },
      CLOSE_MODAL (state) {
        state.modal.current = ''
        state.modal.object = {}
        state.modal.mode = ''

      },
      // SAVE_ACCOUNT_SETUP (state, options) {
      //   Object.entries(options).forEach(([key, value]) => {
      //     state.baseData.account[key] = value
      //   })
      // },

      // This activates the 'select objects' mode
      SELECT_OBJECTS (state, filter) {
        state.selectedObjects.objectsJson = new ObjectsWithId()
        state.selectedObjects.filter = filter || null
      },
      // This deactivates the 'select objects' mode
      STOP_SELECT_OBJECTS (state) {
        state.selectedObjects.objectsJson = null
        state.selectedObjects.filter = null
      },
      // This updates the list of selected objects
      SELECT_OBJECT (state, obj) {
        if (obj && obj.id && state.selectedObjects.objectsJson) {
          if (state.selectedObjects.objectsJson[obj.id]) { // if object already selected, we remove it
            delete state.selectedObjects.objectsJson[obj.id]
          }
          else { // otherwise we add it
            state.selectedObjects.objectsJson[obj.id] = obj
          }
          state.selectedObjects.objectsJson = new ObjectsWithId(state.selectedObjects.objectsJson.values) // to force refresh bindings
        }
      }
    },








    



    
    /////////////////////////////////////////////////////
    ///////////////////// ACTIONS ///////////////////////
    /////////////////////////////////////////////////////
    actions: {
      openModal     ({state, commit}, arg)  {
        commit('OPEN_MODAL', arg)
        return { res: true }
      },
      closeModal    ({state, commit}) {
        commit('CLOSE_MODAL')
        return { res: true }
      },


      async getPaymentCardPin ({state, commit}, card) {
        return await api.getPaymentCardPin(card)
      },




      /////////////////////////// Rest actions: ///////////////////////
      // async getRestObject ({commit}, object) {
      //   NProgress.start()
      //   NProgress.set(0.4)
      //   let res = await api.getRestObject(object)
      //   NProgress.done()
      //   return res
      // },
      // async getRestObjects ({commit}, object) {
      //   NProgress.start()
      //   NProgress.set(0.4)
      //   let res = await api.getRestObjects(object)
      //   NProgress.done()
      //   return res
      // },
      
      
      
      //////////////////////////// Session: //////////////////////////
      async login ({commit}, creds) {
        creds.type = 'affiliate'
        var response = await api.login(creds)
        console.log('Store > login(): response = ', response)
        if (response.errors) {
          console.log('Store > login(): error')
          return response
        }
        else {
          router.push('/dashboard/home')
        }
      },
      
      /** Change the user password */
      async changePassword ({commit}, password) {
        const response = await api.changePassword(password)
        if (!response.errors) {
          router.push('/dashboard')
          return
        }
        else  {
          return response
        }
      },


      /** Clears the session in the local storage, close any open modal, and reroutes to login page */
      async logout ({commit}) {
        console.log('Store > logout()')
        commit('CLEAR_SESSION')
        commit('CLOSE_MODAL')
        router.push('/login')
      },
      async isSessionValid ({commit}) {
         return await api.isSessionValid()
      },
      setToken ({commit}, token) {
        api.setDefaultToken(token)
        return true
      },

      //////////////////////////// Base Data: ////////////////////////////
      // async saveAffiliateProfile ({commit}, obj) {
      //   const res = await api.saveAffiliateProfile(obj)
      //   return res
      // },
      async saveAffiliateUser({commit}, affiliateUser) {
        return await api.saveAffiliateUser(affiliateUser)
      },
      async saveAccountSetup ({commit}, obj) { 
        return await api.saveAccountSetup(obj)
      },
      async claimPaymentCard ({commit, dispatch}, card) {
        const res = await api.claimPaymentCard(card)
        return res

      },


      async submitLead ({state, commit}, lead) {
        console.log('store, submitLead, lead = ', lead)
        const res = await api.submitLead(lead)
        return res
      },



      /////////////////////// FETCH BASE DATA: /////////////////
      async fetchBaseData ({state, commit}) {
          const res = (await api.getBaseData())
          if (res && res.baseData) {
            var baseData = res.baseData
            // console.log('fetchBaseData(): baseData.incentifyerAccounts = ', baseData.incentifyerAccounts)
            console.log('fetchBaseData(): ', baseData)
            // we changes the Arrays<ObjectWithId> into ObjectsWithId objects
            baseData.incentifyerAccountsJson = new ObjectsWithId(baseData.incentifyerAccounts)
            delete baseData.incentifyerAccounts
            commit('UPDATE_BASE_DATA', baseData)
          }
          else {
            // We don't show the session invalid message because the apiService already reroutes to login page
          if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
              Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
            }
            NProgress.done()
          }
          // else return res && res.errors ? res.errors : { errors: [`Couldn't get BaseData.`] }
      },


    
    /////////////////////// FETCH DATA ////////////////////////
    

      async fetchData ({state, commit}, { period = (state.periodSelected ? state.periodSelected.value || 'this month+' : 'this month+'),
                                          scope = router.currentRoute.path.split('/')[2] }={}) {
        console.log(`fetchData(): ${period}, ${scope}`)
        // get the data from the API
        if (!period) {
          console.log('No period provided to store.js: fetchData()')
          return undefined
        }
        // console.log(`Before fetch`)
        NProgress.start()
        // NProgress.inc(0.4)
        const result = await api.fetchData(period, scope)
        // console.log('fetchData get result = ', result)

        if (!result) {
          NProgress.done()
          return result
        }
        if (result.errors) {
          // We don't show the session invalid message because the apiService already reroutes to login page
          if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
            Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
          }
          NProgress.done()
          return { result: false }
        }
        else {
         
          // console.log(`After fetch result = `, result)
          // Data for this period
          if (result.data) {
            if (result.data.data) {
              const data = result.data.data
              if (data.leads && data.leads.length > -1) {
                commit('UPDATE_LEADS', new ObjectsWithId(data.leads))
              }
              if (data.payouts && data.payouts.length > -1) {
                commit('UPDATE_PAYOUTS', new ObjectsWithId(data.payouts))
              }
              if (data.paymentCardLogs && data.paymentCardLogs.length > -1) {
                commit('UPDATE_PAYMENT_CARD_LOGS', data.paymentCardLogs)
              }
            }
            // Data for the previous period
            if (result.data.dataPrevious) {
              const dataPrevious = result.data.dataPrevious
              if (dataPrevious.leads && dataPrevious.leads.length > -1) {
                commit('UPDATE_LEADS_PREVIOUS', new ObjectsWithId(dataPrevious.leads))
              }
              if (dataPrevious.payouts && dataPrevious.payouts.length > -1) {
                commit('UPDATE_PAYOUTS_PREVIOUS', new ObjectsWithId(dataPrevious.payouts))
              }
              if (dataPrevious.paymentCardLogs && dataPrevious.paymentCardLogs.length > -1) {
                commit('UPDATE_PAYMENT_CARD_LOGS_PREVIOUS', dataPrevious.paymentCardLogs)
              }
              // if (dataPrevious.affiliates && dataPrevious.affiliates.length > -1) {
              //   commit('UPDATE_AFFILIATES_PREVIOUS', new ObjectsWithId(dataPrevious.affiliates))
              // }
              // if (dataPrevious.affiliateCompanies && dataPrevious.affiliateCompanies.length > -1) {
              //   commit('UPDATE_AFFILIATE_COMPANIES_PREVIOUS', new ObjectsWithId(dataPrevious.affiliateCompanies))
              // }
            }
            // Data for the evolution graphs
            if (result.dataEvolution) {
              const dataEvolution = result.data.dataEvolution
              if (dataEvolution.leads && dataEvolution.leads.length > -1) {
                commmit('UPDATE_LEADS_EVOLUTION', new ObjectsWithId(dataEvolution.leads))
              }
              if (dataEvolution.payouts && dataEvolution.payouts.length > -1) {
                commmit('UPDATE_PAYOUTS_EVOLUTION', new ObjectsWithId(dataEvolution.payouts))
              }
            }
            NProgress.done()
            return { result: true }
          }
          else {
            NProgress.done()
            return { result: false }
          }
        }
      }
    }
})